// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".back-buttons[data-v-738991cd]{display:flex;flex-direction:column;gap:1rem}.back-buttons[data-v-738991cd] button,.back-buttons a[data-v-738991cd]{width:-moz-fit-content;width:fit-content;padding-left:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
